import { useMemo } from "react";

import { LicencedIntervenor } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicencedIntervenor";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { DoctorSearchAutocomplete } from "@/Common/Components/Search/DoctorSearchAutocomplete";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Person } from "@/Common/Models/Person/Person";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { FaxDirectoryExternalConsultantSearch } from "./FaxDirectoryExternalConsultantSearch";
import { IConsultantProps } from "./IConsultantProps";

interface IConsultantSearchProps extends IConsultantProps {
    patientContactId: string;
    employees: Immutable.List<SearchableItemModelT<any>>;
    onDoctorEmployeeSelect: (person: Person) => void;
    onDoctorSelect: (intervenor: LicencedIntervenor) => void;
    isInternal: boolean;
}

export function ConsultantSearch(props: IConsultantSearchProps): JSX.Element {
    const { getText } = useTranslation();

    const filteredEmployees = useMemo(
        () => props.employees
            .filter(p => {
                const ids = props.patientClinicianModel.get("IntervenorsOnFile").map(p => p.Employee?.ContactFacetId).filter(p => !IsNullOrWhiteSpace(p)).toArray();
                for (const id of ids) {
                    if (id === p.Model.ContactFacetId)
                        return false;
                }
                return true;
            })
            .toList(),
        [props.employees, props.patientClinicianModel]
    );

    return (
        <div>
            {props.intervenor.SearchByEmployee || !cacheStore.ClinicSettings.EnableContactDirectory ? (
                <div>
                    <div>
                        <label>{`${getText("SearchLabel")} :`}</label>
                    </div>
                    <div>
                        {props.isInternal
                            ? (
                                <TextboxControl
                                    className="margin-sm-right"
                                    debounceMs={200}
                                    onMountFocus
                                    value={props.intervenor.GetNameSearch()}
                                    autoCompleteItems={filteredEmployees}
                                    onAutoCompleteSelectCallBack={(_, value: Person) => {
                                        props.onDoctorEmployeeSelect(value);
                                    }}
                                    onAutoCompleteSelectClearTextBox
                                    placeholder=""
                                    valid={props.intervenor.Employee != null}
                                    id="txtEmployees"
                                    dataCy="consultant-search"
                                />
                            )
                            : (
                                <DoctorSearchAutocomplete
                                    focusOnMount
                                    componentId="txtdoctor_ClinicianEdit_Add"
                                    onItemSelectCallback={(value: LicencedIntervenor) => {
                                        props.onDoctorSelect(value);
                                    }}
                                    text={props.intervenor.GetNameSearch()}
                                    isValid={props.intervenor.Model.LicencedIntervenor != null}
                                />
                            )
                        }
                    </div>
                </div>
            ) : (
                <FaxDirectoryExternalConsultantSearch
                    patientContactId={props.patientContactId}
                    isValid={props.intervenor.Model.HealthCareProvider != null}
                    onHealthCareProviderSelect={entity => props.onHealthCareProviderSelect(entity)}
                />
            )
            }
        </div>
    );
}
